<template>
  <v-app>
    <v-toolbar dark fixed flat app color="#024EA1">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <a href="http://www.ks-france.com/fr/" target="_blank">
      <img src="img/logo-kpluss.svg" class="my-3" alt="logo K+S" style="width: 68px"/></a>
      <v-spacer></v-spacer>
      <v-toolbar-title class="headline text-uppercase">
        <img src="img/logo-easyfert-inline-blanc.svg"
                  class="my-3" alt="logo EasyFert"/>
      </v-toolbar-title>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" app absolute temporary>
      <v-flex xs12 justify-center pa-2>
        <img src="img/logo-easyfert-inline-couleur.svg"
          class="center-block" alt="logo"/>
      </v-flex>
      <v-list class="pt-0" dense>
        <v-divider light></v-divider>
        <v-list-tile
          v-for="route in routes"
          :key="route.order"
          :to="route.path"
          :disabled="!route.enabled">
          <v-list-tile-action>
            <v-icon>{{ route.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t(route.libelle) }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container fluid class="page">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: 'App',

  data() {
    return {
      dataLoading: this.$store.state.easyfert.loadData,
      loadingVertical: true,
      loadingTimeout: 5000,
      drawer: null,
      routes: this.$router.options.routes,
    };
  },
  methods: {
    btnNext() {
      console.info(this.$router.currentRoute);
    }
  },
  mounted() {
    this.$store.dispatch('getData');
    this.$store.dispatch(('setRoutes'), this.routes);
  }
};
</script>
